import _ from 'lodash'
import React, { useMemo, useState } from 'react'
import { AutocompleteInput } from '../../../Components/Inputs/AutocompleteInput'
import { InputOptionProps } from '../../../Components/Inputs/Types'
import { AppPermission, useAppPermissions } from '../../../Hooks/useAppPermissions'
import { ConsigneeSchema, ConsigneeType } from '../../../Schema/ConsigneeSchema'
import { CarrierAddDrawer } from '../CarrierAddDrawer'
import { useCarriersSelector } from '../Hooks/useCarriersSelector'

interface CarrierPickerProps {
  consigneeType?: ConsigneeType
  value?: string
  className?: any
  label?: string
  helperText?: string
  onChange: (value: string) => void
  disabled?: boolean
  required?: boolean
  variant?: 'standard' | 'filled' | 'outlined'
  placeholder?: string
  freeSolo?: boolean
  noOptionsText?: string
  clearOnBlur?: boolean
  onCreateNew?: (text: string) => void
  enableCreate?: boolean
  error?: boolean
}

export const CarrierPicker: React.FC<CarrierPickerProps> = ({
  className,
  value,
  label,
  helperText,
  onChange,
  disabled,
  required,
  variant,
  placeholder,
  freeSolo,
  noOptionsText,
  clearOnBlur,
  enableCreate = true,
  error,
}) => {
  const { checkPermissions } = useAppPermissions()

  const [openAdd, setOpenAdd] = useState(false)
  const [text, setText] = useState<string>('')

  const entities = useCarriersSelector()

  const filteredEntities = useMemo(() => {
    return _.map(entities)
  }, [entities])

  const options: InputOptionProps[] = useMemo(() => {
    return _.map(filteredEntities, c => c.getInputOption())
  }, [filteredEntities])

  const handleOnCreate = (name?: string) => {
    setOpenAdd(true)
    setText(
      name,
    )
  }

  const handleOnCloseAdd = (schema?: ConsigneeSchema) => {
    if (schema) {
      onChange(schema.id)
    }
    setOpenAdd(false)
  }
  return (
    <>
    <AutocompleteInput
      value={value}
      className={className}
      label={label}
      helperText={helperText}
      onChange={value => onChange(value as string)}
      disabled={disabled}
      required={required}
      variant={variant}
      placeholder={placeholder}
      freeSolo={freeSolo}
      options={options}
      noOptionsText={noOptionsText}
      clearOnBlur={clearOnBlur}
      onCreateNew={handleOnCreate}
      enableCreate={checkPermissions([AppPermission.CarrierAdd]) && enableCreate}
      error={error}
    />
    {openAdd && <CarrierAddDrawer
      open={openAdd}
      onClose={handleOnCloseAdd}
      defaultData={{
        name: text,
      }}
    />}
    </>
  )
}
